import { addYears, intervalToDuration, isDate, parse } from "date-fns";

function parseDateString(originalValue) {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : parse(originalValue, "dd/MM/yyyy", new Date());

  return parsedDate;
}
export function calculateFullAge({ dob, toEndDate, yearsAdded = 0 }) {
  const endDate =
    toEndDate != null
      ? addYears(parseDateString(toEndDate), yearsAdded)
      : addYears(new Date(), yearsAdded);

  const birthDate = parseDateString(dob);

  const { years, months, days } = intervalToDuration({
    start: birthDate,
    end: endDate,
  });
  return { years, months, days };
}
